import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import CustomEmbed from "./CustomEmbedGigWidget";
import CodeBlock from "../common/CodeBlock";

const BASE_URL = process.env.REACT_APP_BASE_URL;

@inject("embedGigStore")
@observer
class OrganisationEmbedWidget extends Component {

    componentDidMount() {
        const { organisationId } = this.props;
        if (organisationId) {
            this.props.embedGigStore.loadEmbedCodeOrganisation(organisationId);
        }
    }

    handleSave = () => {
        const { organisationId } = this.props;
        return this.props.embedGigStore.createEmbedCodeOrganisation(organisationId);
    };

    getEmbedSrc(embedType, organisationId) {
        const id = organisationId || 0;
        switch (embedType) {
            case 0:  return `${BASE_URL}embedorganisation/${id}`;
            case 1:  return `${BASE_URL}embedtextorganisation/${id}`;
            case 2:
            default: return `${BASE_URL}embedgridorganisation/${id}`;
        }
    }

    render() {
        const { organisationId } = this.props;
        const { embedType } = this.props.embedGigStore;

        const src = this.getEmbedSrc(embedType, organisationId);
        const scriptLink = `<script src="${BASE_URL}js/iframeResizer.min.js"></script>`;

        const iframeTag = `${scriptLink}\n<iframe allowTransparency="true"\n    onload="iFrameResize({},this)" width="100%" height="800"\n    src="${src}"\n    frameborder="0"></iframe>`;

        return (
            <Fragment>
                <CodeBlock
                    code={iframeTag}
                    showCopy={true}
                    showCustomise={false}
                />
                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "8px" }}>
                    <CustomEmbed
                        profile={null}
                        profileId={organisationId || 0}
                        onSave={this.handleSave}
                    />
                </div>
            </Fragment>
        );
    }
}

export default OrganisationEmbedWidget;
